import dynaForms from '@elab/core/utils/dynaForms';

export const storeName = 'deliveryAddressForm';

export default {
    ...dynaForms.getTypes(storeName),
    LOAD_DELIVERY_MODES: `${storeName}.GET_DELIVERY_MODES`,
    SET_DELIVERY_ADDRESS_DATA: `${storeName}.SET_DELIVERY_ADDRESS_DATA`,
    SET_DELIVERY_ADDRESS_OPERATION: `${storeName}.SET_PROFILE_OPERATION`,
    RESET_DATA: `${storeName}.RESET_DATA`,
    SET_DELIVERY_MODES: `${storeName}.SET_DELIVERY_MODES`,
    GET_DELIVERY_TIME: `${storeName}.GET_DELIVERY_TIME`,
    SET_DELIVERY_TIME_SLOTS: `${storeName}.SET_DELIVERY_TIME_SLOTS`,
    SET_DELIVERY_MODE: `${storeName}.SET_DELIVERY_MODE`,
    SET_IS_TIME_SLOT_EMPTY: `${storeName}.SET_IS_TIME_SLOT_EMPTY`,
    SET_FIELDS_ERRORS: `${storeName}.SET_FIELDS_ERRORS`,
};
